// extracted by mini-css-extract-plugin
module.exports = {"SliderItem_figure":"SliderItem_SliderItem_figure__LLz3k","SliderItem_caption":"SliderItem_SliderItem_caption__t7wNm"};